export default __webpack_public_path__ + "static/media/i143vp.e7a27d48.webp";